import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { CarrierLogo } from 'components/CarrierLogo';
import { ReactComponent as WebIcon } from 'icons/website.svg';
import { ReactComponent as DotsIcon } from 'icons/menu.svg';
import LoadingDots from 'components/LoadingDots';
import {
  Container,
  CarrierInfo,
  CarrierLink,
  CarrierName,
  Menu,
  Option,
  CarrierTooltip,
  DotsIconWrapper,
  HyperlinkIcon,
} from './CarrierInformation.styles';
import { useCarrierInforTrackingDetail } from './useCarrierInforTrackingDetail.hook';
import { CarrierPhoneNumber } from './components/CarrierPhoneNumber';
import { CarrierPhoneIcon } from './components/CarrierPhoneIcon';

export const CarrierInformation = () => {
  const { t } = useTranslation();
  const { tertiaryBox } = usePTPConfigContext();
  const {
    isLoading,
    tooltipContent,
    handleToggleTooltip,
    carrierConfig,
    carrierInfo,
  } = useCarrierInforTrackingDetail();

  const {
    isRedirectCarrierTrackingUrl,
    isHyperlinkCarrierTrackingUrl,
    isShowCarrierPhoneNumber,
    isShowCarrierPhoneIcon,
    isShowingSwitcher,
    isShowCarrierName,
    isShowTooltip,
  } = carrierConfig;

  if (isLoading) {
    return <LoadingDots />;
  }

  if (!carrierInfo) {
    return null;
  }

  return (
    <Container data-testid="carrier-info-container">
      <CarrierInfo>
        <CarrierLink
          url={isHyperlinkCarrierTrackingUrl ? carrierInfo?.urlTracking : ''}
          ariaLabel={carrierInfo?.name}
        >
          <span aria-hidden={isHyperlinkCarrierTrackingUrl}>
            <CarrierLogo
              carrierId={carrierInfo?.carrierId}
              carrierName={carrierInfo?.name}
            />
          </span>

          {isShowCarrierName && (
            <CarrierName data-testid="carrier-name" id="carrier-name">
              {carrierInfo?.name}
            </CarrierName>
          )}
          {carrierInfo?.urlTracking && isHyperlinkCarrierTrackingUrl && (
            <HyperlinkIcon />
          )}
        </CarrierLink>

        {isShowCarrierPhoneNumber && carrierInfo?.phone && (
          <CarrierPhoneNumber phone={carrierInfo?.phone} />
        )}
      </CarrierInfo>

      <Menu>
        {isShowCarrierPhoneIcon && carrierInfo?.phone && (
          <CarrierPhoneIcon phone={carrierInfo?.phone} />
        )}
        {carrierInfo?.urlTracking && isRedirectCarrierTrackingUrl && (
          <Option
            data-testid="carrier-redirect-option"
            key="redirect"
            url={carrierInfo?.urlTracking}
            id="carrier-tracking-url"
            ariaLabel={carrierInfo?.name}
          >
            <WebIcon />
          </Option>
        )}
        {isShowingSwitcher && (
          <>
            <Option
              key="menu"
              as="button"
              onClick={handleToggleTooltip}
              aria-label={t('ALT_TEXT_CARRIER_INFORMATION_SWITCH')}
            >
              <DotsIconWrapper data-tooltip-id="carrier-information-switch">
                <DotsIcon width="20px" height="20px" />
              </DotsIconWrapper>
            </Option>

            <CarrierTooltip
              textColor={tertiaryBox.secondaryFontColor}
              backgroundColor={tertiaryBox.bgColor}
              id="carrier-information-switch"
              role="presentation"
              isOpen={isShowTooltip}
              setIsOpen={handleToggleTooltip}
              place="top"
              opacity={1}
              openEvents={{}}
              closeEvents={{}}
              globalCloseEvents={{ clickOutsideAnchor: true, escape: true }}
              clickable
              render={() => tooltipContent}
            />
          </>
        )}
      </Menu>
    </Container>
  );
};
